import { TFieldValidator } from '../../../utils/useSimpleForm';

export const fioValidator: TFieldValidator<string> = value => {
  const valueSplitted = String(value).split(' ');

  if (!(valueSplitted.length >= 2 && valueSplitted[0] && valueSplitted[1])) {
    return 'Введите фамилию и имя через пробел';
  }

  return null;
};
